import React, { useState } from 'react';
import Typography from '../../components/common/Typography';
import AiAssistant from './index';
import SlideRightDialog from '../../components/common/SlideRightDialog';
import { resetAiAssistantState } from './aiAssistantSlice';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const AiAssistantDialog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t: tCommon } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(true);

  const closeAiAssistant = () => {
    setIsOpen(false);
    navigate(-1);
    dispatch(resetAiAssistantState()); // AiAssistant내 state 모두 초기화
  };

  const fontStyle = {
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '28px',
  };

  return (
    <SlideRightDialog
      {...{
        isOpen,
        onClose: closeAiAssistant,
        title: (
          <div className={'displayFlex'}>
            <Typography
              {...{
                variant: '',
                style: fontStyle,
              }}>
              {tCommon('header.title14')}{' '}
              {/* <span
                style={{
                  color: '#BDB4FE',
                  ...fontStyle,
                }}>
                (Beta)
              </span> */}
            </Typography>
          </div>
        ),
        contentStyle: { padding: 0 },
      }}>
      <AiAssistant {...{ isOpen, setIsOpen }} />
    </SlideRightDialog>
  );
};

export default AiAssistantDialog;
